var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/quoted-status.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.to-array.js";
import classNames from 'classnames';
import React, { useState } from 'react';
import { defineMessages, useIntl, FormattedMessage, FormattedList } from 'react-intl';
import { useHistory } from 'react-router-dom';
import StatusMedia from 'soapbox/components/status-media';
import { Stack, Text } from 'soapbox/components/ui';
import AccountContainer from 'soapbox/containers/account_container';
import { useSettings } from 'soapbox/hooks';
import { defaultMediaVisibility } from 'soapbox/utils/status';
const messages = defineMessages({
  cancel: {
    "id": "reply_indicator.cancel",
    "defaultMessage": "Cancel"
  }
});
/** Status embedded in a quote post. */
const QuotedStatus = ({
  status,
  onCancel,
  compose
}) => {
  const intl = useIntl();
  const history = useHistory();
  const settings = useSettings();
  const displayMedia = settings.get('displayMedia');
  const [showMedia, setShowMedia] = useState(defaultMediaVisibility(status, displayMedia));
  const handleExpandClick = e => {
    if (!status) return;
    const account = status.account;
    if (!compose && e.button === 0) {
      history.push(`/@${account.acct}/posts/${status.id}`);
      e.stopPropagation();
      e.preventDefault();
    }
  };
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  };
  const handleToggleMediaVisibility = () => {
    setShowMedia(!showMedia);
  };
  const renderReplyMentions = () => {
    if (!status?.in_reply_to_id) {
      return null;
    }
    const account = status.account;
    const to = status.mentions || [];
    if (to.size === 0) {
      if (status.in_reply_to_account_id === account.id) {
        return /*#__PURE__*/React.createElement("div", {
          className: "reply-mentions",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 69,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "reply_mentions.reply",
          defaultMessage: "Replying to {accounts}",
          values: {
            accounts: `@${account.username}`
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70,
            columnNumber: 13
          }
        }));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "reply-mentions",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "reply_mentions.reply_empty",
          defaultMessage: "Replying to post",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82,
            columnNumber: 13
          }
        }));
      }
    }
    const accounts = to.slice(0, 2).map(account => /*#__PURE__*/React.createElement(React.Fragment, null, "@", account.username)).toArray();
    if (to.size > 2) {
      accounts.push(/*#__PURE__*/React.createElement(FormattedMessage, {
        id: "reply_mentions.more",
        defaultMessage: "{count} more",
        values: {
          count: to.size - 2
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 9
        }
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "reply-mentions",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.reply",
      defaultMessage: "Replying to {accounts}",
      values: {
        accounts: /*#__PURE__*/React.createElement(FormattedList, {
          type: "conjunction",
          value: accounts,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102,
            columnNumber: 23
          }
        })
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 9
      }
    }));
  };
  if (!status) {
    return null;
  }
  const account = status.account;
  let actions = {};
  if (onCancel) {
    actions = {
      onActionClick: handleClose,
      actionIcon: require('@tabler/icons/x.svg'),
      actionAlignment: 'top',
      actionTitle: intl.formatMessage(messages.cancel)
    };
  }
  return /*#__PURE__*/React.createElement(Stack, {
    "data-testid": "quoted-status",
    space: 2,
    className: classNames('mt-3 p-4 rounded-lg border border-solid border-gray-100 dark:border-slate-700 cursor-pointer', {
      'hover:bg-gray-50 dark:hover:bg-slate-700': !compose
    }),
    onClick: handleExpandClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(AccountContainer, _extends({}, actions, {
    id: account.id,
    timestamp: status.created_at,
    withRelationship: false,
    showProfileHoverCard: !compose,
    withLinkToProfile: !compose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 7
    }
  })), renderReplyMentions(), /*#__PURE__*/React.createElement(Text, {
    className: "break-words status__content status__content--quote",
    size: "sm",
    dangerouslySetInnerHTML: {
      __html: status.contentHtml
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(StatusMedia, {
    status: status,
    muted: compose,
    showMedia: showMedia,
    onToggleVisibility: handleToggleMediaVisibility,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 7
    }
  }));
};
export default QuotedStatus;